// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Pricing.css - RECTIFIED FOR COMPACT/ZOOM-OUT FEEL */

.pricing-container {
  min-height: calc(100vh - var(--navbar-height));
  padding-top: var(--navbar-height);
  padding-bottom: 3rem; /* Reduced bottom padding */
  background: var(--gradient-hero);
  overflow-x: hidden; /* Prevent horizontal scroll */
}

.container {
  max-width: 1200px; /* Slightly reduced max-width for better focus */
  margin: 0 auto;
  padding: 0 1.5rem;
}

.pricing-title {
  text-align: center;
  /* Responsive font size: min 1.8rem, max 2.25rem */
  font-size: clamp(1.8rem, 3vw, 2.25rem); 
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  margin-top: 1.5rem; /* Reduced top margin */
  line-height: 1.2;
}

.pricing-subtitle {
  text-align: center;
  color: var(--text-secondary);
  font-size: 1rem; /* Smaller subtitle */
  margin-bottom: 2.5rem; /* Reduced spacing */
  font-weight: 400;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.pricing-cards {
  display: grid;
  /* Adjusted minmax to 240px to allow cards to shrink on smaller screens */
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); 
  gap: 1.5rem; /* Tighter gap */
  margin-bottom: 3rem;
  align-items: stretch; 
}

/* Pricing card structure */
.pricing-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 16px; /* Slightly smaller radius */
  overflow: visible; 
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
}

.pricing-card:hover {
  transform: translateY(-4px); /* Subtle lift */
  box-shadow: var(--shadow-xl);
  border-color: var(--text-accent);
}

/* Recommended Card Styling */
.pricing-card.recommended {
  border: 2px solid var(--text-accent); 
  transform: scale(1.02); /* Subtle scale */
  z-index: 2; 
  box-shadow: 0 15px 30px rgba(220, 38, 38, 0.12);
}

.pricing-card.recommended:hover {
  transform: scale(1.02) translateY(-4px);
}

.recommended-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--gradient-button);
  color: white;
  padding: 0.25rem 1rem; /* Smaller badge */
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.3);
  white-space: nowrap;
}

/* Card header */
.card-header {
  padding: 1.5rem; /* Compact padding */
  text-align: center;
  border-bottom: 1px solid var(--border-primary);
  background-color: var(--bg-secondary); /* Distinct header background */
  border-radius: 16px 16px 0 0;
}

.plan-badge-pill {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
}
.plan-badge-pill.free {
  background-color: #FEF2F2;
  color: #B91C1C;
}
.plan-badge-pill.paid {
  background-color: #ECFDF5;
  color: #047857;
}

.card-header h2 {
  font-size: 1.4rem; /* Smaller plan name */
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.plan-description {
  color: var(--text-secondary);
  font-size: 0.85rem; /* Smaller description */
  margin-bottom: 1rem;
  min-height: 2.5em; 
  line-height: 1.4;
}

/* Pricing display */
.plan-price {
  margin-bottom: 1.25rem;
  color: var(--text-primary);
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.plan-price .amount {
  font-size: 2rem; /* Smaller price */
  font-weight: 700;
  line-height: 1;
}
.pricing-card.recommended .plan-price .amount {
    color: var(--text-accent);
}

.plan-price .period {
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 400;
  margin-left: 2px;
}

/* Buttons */
.plan-button {
  display: block;
  width: 100%;
  padding: 0.65rem 1rem; /* Smaller button */
  border-radius: var(--border-radius-full);
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  text-align: center;
  background-image: var(--gradient-button);
  color: white;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.plan-button:hover {
  box-shadow: var(--shadow-button-hover);
  transform: translateY(-1px);
}

.plan-button.active {
  background-image: none;
  background-color: var(--success-color);
  cursor: default;
}
.plan-button.active:hover {
    transform: none;
    box-shadow: none;
}

.plan-button.outline {
  background-image: none;
  background-color: transparent;
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
}
.plan-button.outline:hover {
  border-color: var(--text-primary);
  background-color: white;
}

/* Features list */
.card-features {
  padding: 1.25rem; /* Compact padding */
  flex: 1 1;
}

.card-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.card-features li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0; /* Tighter rows */
  border-bottom: 1px solid var(--border-primary);
  font-size: 0.85rem; /* Smaller font */
}

.card-features li:last-child {
  border-bottom: none;
}

.feature-name {
  font-weight: 500;
  color: var(--text-primary);
  text-align: left;
}

.feature-value {
  color: var(--text-secondary);
  text-align: right;
  font-size: 0.8rem;
}

/* Footer Section (Top-Up) */
.pricing-footer-section {
  margin-top: 2rem;
  padding: 1.5rem 2rem;
  background: var(--bg-primary);
  border-radius: 16px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-lg);
}

.top-up-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.top-up-content h2 {
  font-size: 1.25rem; /* Smaller footer title */
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.top-up-content p {
  color: var(--text-secondary);
  max-width: 600px;
  font-size: 0.9rem;
}

.top-up-action .cta-button {
    padding: 0.65rem 1.5rem;
    border-radius: var(--border-radius-full);
    font-weight: 600;
    text-decoration: none;
    border: 1px solid var(--border-primary);
    color: var(--text-primary);
    transition: all 0.3s ease;
    font-size: 0.9rem;
    white-space: nowrap;
}
.top-up-action .cta-button:hover {
    border-color: var(--text-accent);
    color: var(--text-accent);
    background-color: var(--bg-secondary);
}

/* Responsive */
@media (max-width: 1024px) {
  .pricing-cards {
     grid-template-columns: repeat(2, 1fr);
     max-width: 800px;
     margin-left: auto;
     margin-right: auto;
  }
  .pricing-card.recommended {
    transform: scale(1);
    z-index: 1;
  }
  .pricing-card.recommended:hover {
    transform: translateY(-4px);
  }
}

@media (max-width: 640px) {
  .pricing-cards {
    grid-template-columns: 1fr;
    max-width: 380px;
  }
  .top-up-card {
      flex-direction: column;
      text-align: center;
  }
  .pricing-title {
    font-size: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Pricing.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,oBAAoB,EAAE,2BAA2B;EACjD,gCAAgC;EAChC,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,iBAAiB,EAAE,gDAAgD;EACnE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sCAAsC;EACtC,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB,EAAE,uBAAuB;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe,EAAE,qBAAqB;EACtC,qBAAqB,EAAE,oBAAoB;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yEAAyE;EACzE,2DAA2D;EAC3D,WAAW,EAAE,gBAAgB;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB,EAAE,4BAA4B;EACjD,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,sBAAsB,EAAE,iBAAiB;EACzC,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,YAAY;EACZ,qBAAqB,EAAE,kBAAkB;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe,EAAE,oBAAoB;EACrC,kBAAkB;EAClB,8CAA8C;EAC9C,qCAAqC,EAAE,+BAA+B;EACtE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB,EAAE,wBAAwB;EAC5C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe,EAAE,kBAAkB;EACnC,gBAAgB;EAChB,cAAc;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,WAAW;EACX,qBAAqB,EAAE,mBAAmB;EAC1C,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,eAAe;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;EACvC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB,EAAE,oBAAoB;EACtC,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB,EAAE,iBAAiB;EACpC,8CAA8C;EAC9C,kBAAkB,EAAE,iBAAiB;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,yBAAyB;EAC7C,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,gBAAgB;IAChB,qBAAqB;IACrB,uCAAuC;IACvC,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,eAAe;AACf;EACE;KACG,qCAAqC;KACrC,gBAAgB;KAChB,iBAAiB;KACjB,kBAAkB;EACrB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;MACI,sBAAsB;MACtB,kBAAkB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* src/styles/Pricing.css - RECTIFIED FOR COMPACT/ZOOM-OUT FEEL */\n\n.pricing-container {\n  min-height: calc(100vh - var(--navbar-height));\n  padding-top: var(--navbar-height);\n  padding-bottom: 3rem; /* Reduced bottom padding */\n  background: var(--gradient-hero);\n  overflow-x: hidden; /* Prevent horizontal scroll */\n}\n\n.container {\n  max-width: 1200px; /* Slightly reduced max-width for better focus */\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.pricing-title {\n  text-align: center;\n  /* Responsive font size: min 1.8rem, max 2.25rem */\n  font-size: clamp(1.8rem, 3vw, 2.25rem); \n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n  margin-top: 1.5rem; /* Reduced top margin */\n  line-height: 1.2;\n}\n\n.pricing-subtitle {\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 1rem; /* Smaller subtitle */\n  margin-bottom: 2.5rem; /* Reduced spacing */\n  font-weight: 400;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.5;\n}\n\n.pricing-cards {\n  display: grid;\n  /* Adjusted minmax to 240px to allow cards to shrink on smaller screens */\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); \n  gap: 1.5rem; /* Tighter gap */\n  margin-bottom: 3rem;\n  align-items: stretch; \n}\n\n/* Pricing card structure */\n.pricing-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 16px; /* Slightly smaller radius */\n  overflow: visible; \n  transition: all 0.3s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-lg);\n}\n\n.pricing-card:hover {\n  transform: translateY(-4px); /* Subtle lift */\n  box-shadow: var(--shadow-xl);\n  border-color: var(--text-accent);\n}\n\n/* Recommended Card Styling */\n.pricing-card.recommended {\n  border: 2px solid var(--text-accent); \n  transform: scale(1.02); /* Subtle scale */\n  z-index: 2; \n  box-shadow: 0 15px 30px rgba(220, 38, 38, 0.12);\n}\n\n.pricing-card.recommended:hover {\n  transform: scale(1.02) translateY(-4px);\n}\n\n.recommended-badge {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--gradient-button);\n  color: white;\n  padding: 0.25rem 1rem; /* Smaller badge */\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.3);\n  white-space: nowrap;\n}\n\n/* Card header */\n.card-header {\n  padding: 1.5rem; /* Compact padding */\n  text-align: center;\n  border-bottom: 1px solid var(--border-primary);\n  background-color: var(--bg-secondary); /* Distinct header background */\n  border-radius: 16px 16px 0 0;\n}\n\n.plan-badge-pill {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-bottom: 0.75rem;\n}\n.plan-badge-pill.free {\n  background-color: #FEF2F2;\n  color: #B91C1C;\n}\n.plan-badge-pill.paid {\n  background-color: #ECFDF5;\n  color: #047857;\n}\n\n.card-header h2 {\n  font-size: 1.4rem; /* Smaller plan name */\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.25rem;\n}\n\n.plan-description {\n  color: var(--text-secondary);\n  font-size: 0.85rem; /* Smaller description */\n  margin-bottom: 1rem;\n  min-height: 2.5em; \n  line-height: 1.4;\n}\n\n/* Pricing display */\n.plan-price {\n  margin-bottom: 1.25rem;\n  color: var(--text-primary);\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n}\n\n.plan-price .amount {\n  font-size: 2rem; /* Smaller price */\n  font-weight: 700;\n  line-height: 1;\n}\n.pricing-card.recommended .plan-price .amount {\n    color: var(--text-accent);\n}\n\n.plan-price .period {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 400;\n  margin-left: 2px;\n}\n\n/* Buttons */\n.plan-button {\n  display: block;\n  width: 100%;\n  padding: 0.65rem 1rem; /* Smaller button */\n  border-radius: var(--border-radius-full);\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-decoration: none;\n  text-align: center;\n  background-image: var(--gradient-button);\n  color: white;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n}\n\n.plan-button:hover {\n  box-shadow: var(--shadow-button-hover);\n  transform: translateY(-1px);\n}\n\n.plan-button.active {\n  background-image: none;\n  background-color: var(--success-color);\n  cursor: default;\n}\n.plan-button.active:hover {\n    transform: none;\n    box-shadow: none;\n}\n\n.plan-button.outline {\n  background-image: none;\n  background-color: transparent;\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n.plan-button.outline:hover {\n  border-color: var(--text-primary);\n  background-color: white;\n}\n\n/* Features list */\n.card-features {\n  padding: 1.25rem; /* Compact padding */\n  flex: 1;\n}\n\n.card-features ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.card-features li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.6rem 0; /* Tighter rows */\n  border-bottom: 1px solid var(--border-primary);\n  font-size: 0.85rem; /* Smaller font */\n}\n\n.card-features li:last-child {\n  border-bottom: none;\n}\n\n.feature-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.feature-value {\n  color: var(--text-secondary);\n  text-align: right;\n  font-size: 0.8rem;\n}\n\n/* Footer Section (Top-Up) */\n.pricing-footer-section {\n  margin-top: 2rem;\n  padding: 1.5rem 2rem;\n  background: var(--bg-primary);\n  border-radius: 16px;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-lg);\n}\n\n.top-up-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.top-up-content h2 {\n  font-size: 1.25rem; /* Smaller footer title */\n  color: var(--text-primary);\n  margin-bottom: 0.25rem;\n}\n\n.top-up-content p {\n  color: var(--text-secondary);\n  max-width: 600px;\n  font-size: 0.9rem;\n}\n\n.top-up-action .cta-button {\n    padding: 0.65rem 1.5rem;\n    border-radius: var(--border-radius-full);\n    font-weight: 600;\n    text-decoration: none;\n    border: 1px solid var(--border-primary);\n    color: var(--text-primary);\n    transition: all 0.3s ease;\n    font-size: 0.9rem;\n    white-space: nowrap;\n}\n.top-up-action .cta-button:hover {\n    border-color: var(--text-accent);\n    color: var(--text-accent);\n    background-color: var(--bg-secondary);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .pricing-cards {\n     grid-template-columns: repeat(2, 1fr);\n     max-width: 800px;\n     margin-left: auto;\n     margin-right: auto;\n  }\n  .pricing-card.recommended {\n    transform: scale(1);\n    z-index: 1;\n  }\n  .pricing-card.recommended:hover {\n    transform: translateY(-4px);\n  }\n}\n\n@media (max-width: 640px) {\n  .pricing-cards {\n    grid-template-columns: 1fr;\n    max-width: 380px;\n  }\n  .top-up-card {\n      flex-direction: column;\n      text-align: center;\n  }\n  .pricing-title {\n    font-size: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
